/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A request to create an activity event
 * @export
 * @interface CreateActivityEventRequest
 */
export interface CreateActivityEventRequest {
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof CreateActivityEventRequest
     */
    rID: string;
    /**
     * The activity action that occurred
     * @type {string}
     * @memberof CreateActivityEventRequest
     */
    action: string;
    /**
     * Additional details about the activity event as key-value pairs
     * @type {{ [key: string]: string; }}
     * @memberof CreateActivityEventRequest
     */
    details?: { [key: string]: string; };
}

/**
 * Check if a given object implements the CreateActivityEventRequest interface.
 */
export function instanceOfCreateActivityEventRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "rID" in value;
    isInstance = isInstance && "action" in value;

    return isInstance;
}

export function CreateActivityEventRequestFromJSON(json: any): CreateActivityEventRequest {
    return CreateActivityEventRequestFromJSONTyped(json, false);
}

export function CreateActivityEventRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateActivityEventRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rID': json['RID'],
        'action': json['action'],
        'details': !exists(json, 'details') ? undefined : json['details'],
    };
}

export function CreateActivityEventRequestToJSON(value?: CreateActivityEventRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'RID': value.rID,
        'action': value.action,
        'details': value.details,
    };
}

